import {useState} from 'react';
import {postAuthEmail} from 'api/auth';
import Cookies from 'utils/cookies';
import {alertByError} from 'utils/alerts';

function useLoginEmail(callback) {
  const [isLoading, setIsLoading] = useState(false);

  async function loginEmail(formData) {
    setIsLoading(true);
    try {
      const {data} = await postAuthEmail(formData);
      const {email_session_id} = data;
      const {email} = formData;

      const emailSession = {email_session_id, email};
      Cookies.emailSession = emailSession;

      setIsLoading(false);
      if (callback) callback(emailSession);
    } catch (e) {
      await alertByError(e);
      setIsLoading(false);
    }
  }

  return {isLoading, loginEmail};
}

export default useLoginEmail;
